
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/view/admin/layout/layout'
Vue.use(Router)

export const constantRouterMap = [
  { // login object start
    path: '/login',
    component: () => import('@/view/admin/login/login'),
    hidden: true,
    name: 'login',
    meta: {
      title: 'login',
      selected: false,
      permissionList: ['abc', 'def']
    }
  },
  { // error object start
    path: '/error/404',
    component: () => import('@/view/errorPages/404'),
    hidden: true,
    name: '404',
    meta: {
      title: 'error',
      selected: false
    }
  },
  // { // main page
  //   path: '/dashboard',
  //   redirect: 'dashboard',
  //   hidden: true,
  //   meta: {
  //     title: '',
  //     selected: false
  //   }
  // },
  { // dashboard object start
    path: '/',
    component: Layout,
    hidden: false,
    redirect: 'dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard',
      icon: 'dashboard',
      selected: false,
      permission: ''
    },
    children: [{
      path: 'dashboard',
      component: () => import('@/view/admin/dashboard/dashboard1'),
      name: 'dashboard',
      meta: {
        title: 'Dashboard',
        permissionList: ['abc', 'def']
      }
    }]
  },
  { // schedule object start
    path: '/company',
    component: Layout,
    hidden: false,
    redirect: '/company/companyList',
    name: 'company',
    meta: {
      title: 'Company',
      icon: 'business',
      selected: false,
      permission: 'jobs'
    },
    children: [{
      path: 'companyList',
      component: () => import('@/view/admin/company/companyList'),
      name: 'companyList',
      meta: {
        title: 'companyList',
        permissionList: ['abc', 'def']
      }
    },
    {
      path: 'companydetail/:companyId',
      component: () => import('@/view/admin/company/companyDetail'),
      name: 'companydetail',
      meta: {
        title: 'companydetail',
        permissionList: ['abc', 'def']
      }
    },
    {
      path: 'emailConfigDetails/:emailConfigId',
      component: () => import('@/view/admin/company/emailConfigDetails'),
      name: 'emailConfigDetails',
      meta: {
        title: 'emailConfigDetails',
        permissionList: ['abc', 'def']
      }
    }]
  },
  { // setting object start
    path: '/settings',
    component: Layout,
    hidden: false,
    redirect: '/settings/allSettings',
    name: 'allSettings',
    meta: {
      title: 'Settings',
      icon: 'settings',
      selected: false,
      permission: 'settings'
    },
    children: [{
      path: 'allSettings',
      component: () => import('@/view/admin/settings'),
      name: 'allSettings',
      meta: {
        title: 'Settings',
        permissionList: ['settings']
      }
    },
    {
      path: 'userList',
      component: () => import('@/view/admin/settings/user/userList'),
      name: 'userList',
      meta: {
        title: 'Users',
        settingText: 'Users',
        permissionList: ['users']
      }
    },
    {
      path: 'userDetail/:superAdminUserId',
      component: () => import('@/view/admin/settings/user/userDetail'),
      name: 'userDetail',
      meta: {
        title: 'UserDetail',
        settingText: 'User detail',
        permissionList: []
      }
    },
    {
      path: 'addNewUser',
      component: () => import('@/view/admin/settings/user/addNewUser'),
      name: 'addNewUser',
      meta: {
        title: 'addNewUser',
        settingText: 'Add new user',
        permissionList: []
      }
    },
    {
      path: 'applicationSetting',
      component: () => import('@/view/admin/settings/applicationSettings/applicationSettingDetails'),
      name: 'applicationSetting',
      meta: {
        title: 'applicationSettingDetails',
        settingText: 'Application setting',
        permissionList: []
      }
    }]
  }
]
export default new Router({
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js